// TODO make dynamic as two templates. Text-Ads & Image-Ads

export const soladsTemplateDataId = "solads-before-pagination-sol"

export const soladsBeforePaginationHtmlMobile = `<div id="page-bottom-sol" data-solads-id="${soladsTemplateDataId}"
    class="page-stripe page-stripe-page-bottom-sol  no-solads-label extra-top-spacing text-center">
    <div class="container">
        <div class="row-page-bottom-sol base-row row">
            <div class="sol-content relative text-center content-width-320">
                <div class="sol-advert-mark">
                    <span class="sol-label"><a href="https://www.solads.media/" target="_blank"
                            rel="nofollow">SolAds</a></span>
                    <small class="sol-text-label">Anzeige</small>
                </div>
                <div class="sol-frame sol-type-text" data-banner-free-type="ausblenden">
                    <script data-params="jsads">
                        m3ads_system = "Solads";
                        m3ads_partnernumber = 379946;
                        m3ads_subpartner = "m-ladies-bottom";
                        m3ads_numberadverts = 1;
                        m3ads_sectors = "2007";
                        m3ads_logoimagewidth = 250;
                        m3ads_logoimageheight = 250;
                    </script>
                </div>
            </div>
        </div>
    </div>
</div>`

export const soladsBeforePaginationHtmlPc = `<div class="solads-container" data-solads-id="${soladsTemplateDataId}">
    <div class="item clearfix text-left">
        <div class="sol-content relative col-xs-12 content-width-240">
            <div class="sol-advert-mark">
                <span class="sol-label"><a href="https://www.solads.media/" target="_blank"
                        rel="nofollow">SolAds</a></span>
                <small class="sol-text-label">Anzeigen</small>
            </div>
            <div class="sol-frame image-width-240 sol-text-1-row sol-type-text" data-columns="2">
                <script data-params="jsads">
                    m3ads_system = "Solads";
                    m3ads_partnernumber = 379946;
                    m3ads_subpartner = "ladies";
                    m3ads_numberadverts = 2;
                    m3ads_sectors = "2007";
                    m3ads_logoimagewidth = 250;
                    m3ads_logoimageheight = 250;
                </script>
            </div>
        </div>
    </div>
</div>`

export const soladsBottomPc = `<section
id="page-closing-sol"
class="page-stripe page-stripe-page-closing-sol white shadow"
>
<div class="container">
    <div class="row-page-closing-sol base-row row">
        <div class="sol-content relative content-width-728">
            <div class="sol-advert-mark">
                <span class="sol-label"><a href="https://www.solads.media/" target="_blank" rel="nofollow">SolAds</a></span>
                <small class="sol-text-label">Anzeige</small>
            </div>
            <div class="sol-frame sol-type-text display-height-xs-auto display-height-lg-90" data-banner-free-type="ausblenden" >
                <script type="text/javascript" data-params="jsads">
                    m3ads_system = "Solads";
                    m3ads_partnernumber = 379946;
                    m3ads_subpartner = "ladies";
                    m3ads_numberadverts = 1;
                    m3ads_notitle = true;
                    m3ads_sectors = "2007";
                    m3ads_logoimagewidth = 250;
                    m3ads_logoimageheight = 250;
                </script>
                </div>
            </div>
        </div>
    </div>
</section>`
